<template>
  <div>
    <a-card size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">{{ title }}</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>筛选：项目迭代</p>
            <p>描述：所选迭代需求移入移出及迭代当前需求总数变化趋势</p>
            <p>排序：操作时间（默认）</p>
            <p>操作：点击柱状图可查看需求移入移出记录</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <a-form-model slot="extra" class="search-form" layout="inline">
        <a-form-model-item label="项目">
          <a-select v-model="project_id" allow-clear placeholder="项目" style="width: 240px" @change="onProjectChange">
            <a-select-option v-for="project in projects" :key="project.id" :value="project.id">{{ project.name }} </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="迭代">
          <a-select v-model="version_id" allow-clear placeholder="迭代" style="width: 240px" @change="onVersionChange">
            <a-select-option v-for="version in versions" :key="version.id" :value="version.id">{{ version.title }} </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div id="req-add-remove-trend" :style="{ height: height, width: width }" />
    </a-card>
    <req-add-remove-modal ref="req-add-remove-modal" />
  </div>
</template>
<script>
import { reqAddRemTrend } from '@/api/data/requirement';
import { versionList } from '@/api/project/version';
import { projectList } from '@/api/project/project';
import ReqAddRemoveModal from '@/pages/data/requirement/components/ReqAddRemoveModal';

export default {
  components: { ReqAddRemoveModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'person',
      myChart: null,
      titleDict: {},
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '5%',
          right: '7%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            startValue: 0,
            endValue: 10
          }
        ]
      },
      items: [],
      xAxisData: [],
      series: [],
      title: '迭代变化趋势',
      versions: [],
      projects: [],
      project_id: null,
      version_id: null
    };
  },
  watch: {
    filterForm() {
      this.getReqAddRemTrend();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    require('echarts/lib/chart/line');
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById('req-add-remove-trend'));
    const self = this;
    this.myChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (self.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        self.onDetail(index);
      }
    });
    this.getProjectList();
    this.getVersionList();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getReqAddRemTrend() {
      reqAddRemTrend({ version_id: this.version_id }).then(res => {
        if (Object.keys(res.data).length === 0) {
          return;
        }
        this.items = res.data.items;
        this.titleDict = res.data.title_dict;
        const versionInfo = res.data.version;
        this.title = '迭代变化趋势: ' + versionInfo.name + ' (' + versionInfo.start + ' ~ ' + versionInfo.end + ')';
        this.option.xAxis.data = res.data.x_axis;
        this.option.series = [
          {
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              formatter: params => (params.value > 0 ? params.value : ' ')
            },
            name: '移入',
            data: res.data.req_add_series,
            stack: 'trend'
          },
          {
            type: 'bar',
            label: {
              show: true,
              position: 'inside',
              formatter: params => (params.value > 0 ? params.value : ' ')
            },
            name: '移出',
            data: res.data.req_remove_series,
            stack: 'trend'
          },
          {
            type: 'line',
            name: '当前需求总数',
            data: res.data.req_current_series,
            smooth: true
          }
        ];
        this.drawChart();
      });
    },
    onProjectChange() {
      this.getVersionList(this.project_id);
    },
    getProjectList() {
      projectList({}).then(res => {
        this.projects = res.data.projects;
        this.project_id = this.projects[0].id;
      });
    },
    onVersionChange(value) {
      this.version_id = value;
      this.getReqAddRemTrend();
    },
    getVersionList(projectId = 1) {
      versionList({ project_id: projectId }).then(res => {
        this.versions = res.data.list;
        this.version_id = this.versions[0].id;
        this.getReqAddRemTrend();
      });
    },

    onDetail(index) {
      this.$refs['req-add-remove-modal'].onOpen(this.items[index].add_data, this.items[index].remove_data);
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}

/deep/ .ant-form-item {
  display: inline-block !important;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}
</style>
